import React from 'react'
import { Tabs, Tab } from 'react-bootstrap'

import ChartsList from './ChartsList'

const SubmittedCharts = (props) => {
  const {
    routerProps,
    charts,
  } = props

  let pendingInvestigatorReviewCharts = []
  if (charts && charts.pending_investigator_review) {
    pendingInvestigatorReviewCharts = charts.pending_investigator_review
  } else if (charts && charts.unapproved) {
    pendingInvestigatorReviewCharts = charts.unapproved
  }

  return (
    <Tabs defaultActiveKey="incomplete">
      <Tab eventKey="incomplete" title="Incomplete">
        <ChartsList
          title="Incomplete"
          routerProps={routerProps}
          charts={charts.incomplete || []}
        />
      </Tab>

      <Tab eventKey="pending_investigator_review" title="Pending Investigator Review">
        <ChartsList
          title="Pending Investigator Review"
          routerProps={routerProps}
          charts={pendingInvestigatorReviewCharts || []}
        />
      </Tab>

      <Tab eventKey="requires_revisions" title="Requires Revisions">
        <ChartsList
          title="Requires Revisions"
          routerProps={routerProps}
          charts={charts.requires_revisions || []}
        />
      </Tab>

      <Tab eventKey="requires_data_manager_validation" title="Pending Data Manager Validation">
        <ChartsList
          title="Pending Data Manager Validation"
          routerProps={routerProps}
          charts={charts.requires_data_manager_validation || []}
        />
      </Tab>

      <Tab eventKey="charts_requiring_data_manager_revisions" title="Requires Data Validation">
        <ChartsList
          title="Requires Data Validation"
          routerProps={routerProps}
          charts={charts.charts_requiring_data_manager_revisions || []}
        />
      </Tab>

      <Tab eventKey="screening_failure_charts" title="Screening Failure">
        <ChartsList
          title="Screening Failure"
          routerProps={routerProps}
          charts={charts.screening_failure_charts || []}
        />
      </Tab>

      {/* <Tab eventKey="pending_pv_review" title="Pending PV Review">
        <ChartsList
          title="Pending Pharmacovigilance Review"
          routerProps={routerProps}
          charts={charts.pending_pv_review || []}
        />
      </Tab> */}

      {/* <Tab eventKey="requires_adr_validation" title="Requires ADR Validation">
        <ChartsList
          title="Requires ADR Validation"
          routerProps={routerProps}
          charts={charts.requires_adr_validation || []}
        />
      </Tab> */}

      <Tab eventKey="approved" title="Approved">
        <ChartsList
          title="Approved"
          routerProps={routerProps}
          charts={charts.approved || []}
        />
      </Tab>
    </Tabs>
  )
}


export default SubmittedCharts
